export default "__VITE_ASSET__c077c9ae__"